<template>
  <div id="app">
    <router-view></router-view>
    <el-dialog
      ref="versionDialog"
      title="更新提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span class="versionDialog" v-html="versionBody"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getVersion, setVersion } from 'tools/storage'
  export default {
    name: 'app',
    data () {
      return {
        dialogVisible: false,
        newVersion: '2.4.9'
      }
    },
    created () {
      setTimeout(() => {
        let version = getVersion()
        if (version !== null) {
          setVersion(this.newVersion)
          if (version !== this.newVersion) {
            this.dialogVisible = true
          }
        } else {
          setVersion(this.newVersion)
          this.dialogVisible = true
        }
      }, 500)
    },
    computed: {
      versionBody () {
        return `<font style="color:#409EFF;">版本号：${this.newVersion}</font><br/>
            1. 新增：项目信息增加定位类型选择功能</br>
          </div>`
      }
    }
  }
</script>

<style scoped>
  #app {
    background: #f9f9f9
  }
  .el-dialog__body {
    padding: 30px 20px;
  }
  .el-dialog__body {
    padding: 10px 17px;
  }
  .versionDialog {
    text-align: center;
    font-size: 16px;
  }
</style>

